export const initialNodes = [
  {
    id: "titleIntentNode",
    position: { x: 162, y: 313 },
    positionBefore: { x: 162, y: 313 },
    type: "titleIntentNode",
  },
  {
    id: "buttonAdd-1",
    sourcePosition: "left",
    targetPosition: "right",
    position: { x: 552.5, y: 361.5 },
    positionBefore: { x: 552.5, y: 361.5 },
    type: "buttonAdd",
    data: {
      offsetXbutton:390.5,
      offsetYbutton:48.5,
      parentData: {
        id: "titleIntentNode",
        type: "titleIntentNode",
        position: { x: 162, y: 313 },
      },
    },
  },
];
export const initialEdges = [
  {
    id: "add-edge-1",
    source: "titleIntentNode",
    sourceHandle: "titleHandle",
    target: "buttonAdd-1",
    type: "smoothstep",
    animated: true,
    data: {},
  },
  {
    id: "add-edge-2",
    source: "titleIntentNode",
    target: "entryNode",
    type: "default",
    animated: true,
    data: {},
  },
];
